import { NotificaionsBase }   from "../base";
import { api }       from "apps/api";
import moment from 'moment';
import InviewManager from "utilities/inview";
import {
  NOTIFICATION_READ
} from 'apps/events';

export class NotificaionsItemsItem extends NotificaionsBase {
  inviewManager: InviewManager;
  init(){
    super.init();
    this.watch();
    this.listenMount([this.onMountNotificationItem]);
  }
  onMountNotificationItem(){
    this.setOnReadEvent();
  }
  setOnReadEvent(){
    if(!this.opts.unread){ return; }
    if(!this.parentOpts().inview){ return; }
    if(this.inviewManager){
      this.inviewManager.destroy();
      this.inviewManager = undefined;
    }
    this.inviewManager = new InviewManager(this.rootElement(), () => { this.onRead() });
  }
  onRead(){
    let customEvent = new CustomEvent(NOTIFICATION_READ, {detail: [this.opts.id] });
    window.dispatchEvent(customEvent);
  }
}
riot.mixin('notifications.items.item', NotificaionsItemsItem as riot.TagMixin)
